import style from '../OnboardingEgyptLuckyV1.css';
import useTranslation from '../../../../localization/i18n.context';
import Alert from '../../../shared/Alert/Alert';
import Button from '../../../shared/Button/Button';
import TextField from '../../../shared/TextField/TextField';
import Title from '../../../shared/Typography/Title';

const NAME_MAX_LENGTH = 10;
const FAMILY_NAME_MAX_LENGTH = 15;
const MIN_LENGTH = 3;

const StepField = {
  FIRST_NAME: 'personal info english - first name',
  FAMILY_NAME: 'personal info english - family name',
};

export default function FormStep2({
  onInputChange,
  onButtonClick,
  data = {},
  isPersonalized = false,
}) {
  const { t } = useTranslation();

  const firstName = data[StepField.FIRST_NAME].value?.trim();
  const familyName = data[StepField.FAMILY_NAME].value?.trim();

  const fieldsAreFilled = Object.values(StepField).every(
    field => data[field].value && data[field].value?.trim(),
  );

  const fieldsHaveRightLength =
    firstName?.length >= MIN_LENGTH &&
    firstName?.length <= NAME_MAX_LENGTH &&
    familyName?.length >= MIN_LENGTH &&
    familyName?.length <= FAMILY_NAME_MAX_LENGTH;

  const areEnglishNames =
    !/^[\u0600-\u06FF\s]+$/gm.test(firstName) &&
    !/^[\u0600-\u06FF\s]+$/gm.test(familyName);

  const isButtonEnabled =
    fieldsAreFilled && fieldsHaveRightLength && areEnglishNames;

  return (
    <main className={style.main}>
      <div className={style['form-content']}>
        <div className={style['form-title']}>
          <Title text={t('Enter your name and family name in English')} />
        </div>
        <div className={style['form-alert']}>
          <Alert
            hasIcon
            type={isPersonalized ? Alert.Type.WARNING : Alert.Type.INFO}
            message={t(
              isPersonalized
                ? 'The name you provide will be printed exactly as entered on your card (up to 25 characters)'
                : 'Please enter your first and last name in English (up to 25 characters)',
            )}
          />
        </div>
        <div className={style['form-inputs']}>
          <div className={style['form-control']}>
            <TextField
              label={t('Name')}
              placeholder={t('E.g. Moustafa')}
              maxLength={NAME_MAX_LENGTH}
              onInput={onInputChange}
              value={data[StepField.FIRST_NAME]?.value}
              name={StepField.FIRST_NAME}
            />
          </div>

          <div className={style['form-control']}>
            <TextField
              label={t('Family name')}
              placeholder={t('E.g. Mhamed')}
              maxLength={FAMILY_NAME_MAX_LENGTH}
              onInput={onInputChange}
              value={data[StepField.FAMILY_NAME]?.value}
              name={StepField.FAMILY_NAME}
            />
          </div>
        </div>
      </div>
      <div className="fixed-cta">
        <Button fullWidth onClick={onButtonClick} disabled={!isButtonEnabled}>
          {t('Continue')}
        </Button>
      </div>
    </main>
  );
}
FormStep2.Type = 'FormStep2';
FormStep2.EventName = 'personal_info_english';
